import LegalPageLayout from '../components/LegalPageLayout';

export default function TermsPage() {
  const sections = [
    {
      title: 'Kabul',
      content: <p>Bu web sitesini kullanarak, aşağıdaki kullanım şartlarını kabul etmiş sayılırsınız. Bu şartları kabul etmiyorsanız, lütfen web sitemizi kullanmayın.</p>,
    },
    {
      title: 'Hizmet Tanımı',
      content: <p><strong className="text-white">Medyatik Interactive</strong>, dijital pazarlama, web tasarımı, nöro-pazarlama stratejileri ve yapay zeka destekli büyüme sistemleri alanlarında profesyonel hizmetler sunan bir dijital ajanstır.</p>,
    },
    {
      title: 'Fikri Mülkiyet Hakları',
      content: (
        <>
          <p>Bu web sitesindeki tüm içerik, tasarım, grafikler, logolar, simgeler, görseller, metinler ve yazılımlar Medyatik Interactive'in mülkiyetindedir ve telif hakları, ticari marka hakları ve diğer fikri mülkiyet hakları ile korunmaktadır.</p>
          <p>Yazılı izin almaksızın bu içeriklerin kopyalanması, dağıtılması, değiştirilmesi veya herhangi bir şekilde kullanılması yasaktır.</p>
        </>
      ),
    },
    {
      title: 'Kullanıcı Yükümlülükleri',
      content: (
        <ul className="list-disc pl-5 space-y-1">
          <li>Yasalara ve düzenlemelere uygun davranmak</li>
          <li>Yanlış veya yanıltıcı bilgi vermemek</li>
          <li>Web sitesinin güvenliğini tehlikeye atacak eylemlerden kaçınmak</li>
          <li>Diğer kullanıcıların haklarına saygı göstermek</li>
          <li>Spam veya istenmeyen içerik göndermemek</li>
        </ul>
      ),
    },
    {
      title: 'Sorumluluk Reddi',
      content: (
        <>
          <p>Web sitemizdeki bilgiler genel bilgilendirme amaçlıdır ve profesyonel tavsiye niteliği taşımamaktadır.</p>
          <p>Web sitesinin kesintisiz, hatasız veya virüssüz olacağını garanti etmiyoruz. Web sitesinin kullanımından doğabilecek doğrudan veya dolaylı zararlardan sorumlu değiliz.</p>
        </>
      ),
    },
    {
      title: 'Üçüncü Taraf Bağlantılar',
      content: <p>Web sitemiz, üçüncü taraf web sitelerine bağlantılar içerebilir. Bu bağlantılar kolaylık sağlamak amacıyla sunulmaktadır ve bu sitelerin içeriğinden veya gizlilik uygulamalarından sorumlu değiliz.</p>,
    },
    {
      title: 'Hizmet Değişiklikleri',
      content: <p>Medyatik Interactive, web sitesini ve sunulan hizmetleri önceden bildirimde bulunmaksızın değiştirme, askıya alma veya sonlandırma hakkını saklı tutar.</p>,
    },
    {
      title: 'Tazminat',
      content: <p>Bu kullanım şartlarını ihlal etmeniz veya web sitesini uygunsuz kullanmanız nedeniyle Medyatik Interactive'in uğrayabileceği her türlü zarar, kayıp ve masrafı tazmin etmeyi kabul edersiniz.</p>,
    },
    {
      title: 'Uygulanacak Hukuk',
      content: <p>Bu kullanım şartları Türkiye Cumhuriyeti kanunlarına tabidir. Herhangi bir uyuşmazlık durumunda İstanbul Mahkemeleri ve İcra Daireleri yetkilidir.</p>,
    },
    {
      title: 'Şartların Değiştirilmesi',
      content: <p>Bu kullanım şartlarını herhangi bir zamanda değiştirme hakkını saklı tutuyoruz. Değişiklikler web sitesinde yayınlandığı anda yürürlüğe girer.</p>,
    },
    {
      title: 'İletişim',
      content: <p><strong className="text-zinc-300">E-posta:</strong> info@medyatik.app<br /><strong className="text-zinc-300">Adres:</strong> Esentepe Mah. Talatpaşa Cad. No: 5/1, 34394 Şişli/İstanbul<br /><strong className="text-zinc-300">Telefon:</strong> +90 532 168 62 82</p>,
    },
  ];

  return <LegalPageLayout title="Kullanım Şartları" date="Son Güncelleme: Aralık 2024" sections={sections} testId="terms-page" />;
}
